export var resolveTimeout = function resolveTimeout(timeout, resolveWith) {
  return new Promise(function (resolve, _reject) {
    setTimeout(resolve, timeout, resolveWith);
  });
};
export var rejectTimeout = function rejectTimeout(timeout, rejectWith) {
  return new Promise(function (_resolve, reject) {
    setTimeout(reject, timeout, rejectWith);
  });
};